import React from 'react';
import { ProductMockup } from './ProductMockup';
const ITEMS = [{
  n: 'i',
  meta: 'Recurso principal',
  title: 'La Guía de Transformación Corporal',
  desc: 'El método A.R.M.O.N.Y. completo. Seis fases para preparar la decisión: claridad emocional, evaluación de clínicas, planificación financiera, optimización física, recuperación e integración. Un orden para decidir, no más información suelta.'
}, {
  n: 'ii',
  meta: 'Recurso de recuperación',
  title: 'Código de Recuperación™',
  desc: 'El valle predecible de los días 8–14 que nadie te advierte — mapeado al día. Frases concretas para sostener la fase más difícil sin tomar decisiones desde el dolor.'
}, {
  n: 'iii',
  meta: 'Recurso de consulta',
  title: 'Guion de Consulta™',
  desc: 'Las preguntas exactas que llevas a tu valoración. Cómo distinguir una clínica seria de una oportunista en tiempo real — y cómo reconocer la presión disfrazada de oferta.'
}, {
  n: 'iv',
  meta: 'Recurso de proceso',
  title: 'Línea de Tiempo de Transformación™',
  desc: 'Mapa visual de 90 días — físico, emocional, financiero y social. Sabes qué viene en cada fase, qué se siente normal y qué requiere atención.'
}];
export function WhatsInside() {
  return <section className="section" data-id="element-175">
      <h2 className="section-h2" data-id="element-176">El bundle completo. Un solo método.</h2>

      <p className="section-lead" data-id="element-177">
        Cuatro recursos digitales que trabajan en secuencia: cada uno cubre una
        capa distinta de la decisión — emocional, clínica, financiera y de
        recuperación. No estás comprando información suelta. Estás entrando a un
        sistema.
      </p>

      <ProductMockup data-id="element-178" />

      <div className="inside-list" data-id="element-179">
        {ITEMS.map(item => <div key={item.n} className="inside-item" data-id="element-180">
            <span className="inside-num" data-id="element-181">{item.n}</span>
            <div data-id="element-182">
              <div className="inside-meta" data-id="element-183">{item.meta}</div>
              <h3 className="inside-title" data-id="element-184">{item.title}</h3>
              <p className="inside-desc" data-id="element-185">{item.desc}</p>
            </div>
          </div>)}
      </div>
    </section>;
}